import { Button, styled, Typography } from '@mui/material';
import type { FC } from 'react';
import { useQuickBooksConnect } from '../../../../../../hooks/requests/use-quickbooks-connect';
import { runMutation } from '../../../../../../utils/vy-mutation';
import { VyIcon } from '@vy/ui-design-system';

export const QuickBooksRegistration: FC = () => {
  const connectQuickBooksMutation = useQuickBooksConnect();

  const handleConnectClick = async () => {
    await runMutation(connectQuickBooksMutation, undefined, {
      pending: 'Connecting...',
      success: 'Redirecting...',
      error: 'Failed to connect',
    });
  };

  return (
    <FormContainer>
      <LogoContainer>
        <VyIcon
          icon="QuickbooksLogoIcon"
          style={{
            transform: 'scale(0.5)',
            transformOrigin: 'top left',
          }}
        />
      </LogoContainer>
      <Typography variant="h4">Connect to QuickBooks</Typography>
      <Typography variant="h6">Click here to authorize from QuickBooks</Typography>
      <Button onClick={handleConnectClick} variant="contained">
        Connect
      </Button>
    </FormContainer>
  );
};

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

const LogoContainer = styled('div')({
  width: 132,
  height: 132,
});
